import { Redirect } from '../Router'

const PageNotFound = ({ locale }) => <Redirect to={`/${locale}`} />

export default PageNotFound
